import { Component, OnInit, ViewChild, Input, Inject, Output, EventEmitter, AfterViewInit, ContentChild, TemplateRef } from '@angular/core';

import { MatDialogConfig, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Site } from 'solar-bo';
import { SiteEditComponent } from './site-edit.component';


@Component({
  selector: 'app-site-edit-dlg',
  templateUrl: './site-edit-dlg.component.html'
})
export class SiteEditDlgComponent implements OnInit, AfterViewInit {

  title: string = "Site";
  titlesub: string = "";
  submitted: boolean = false;
  @Output() saveEvent = new EventEmitter<Site>();
  @Input() site: Site = new Site();
  @ViewChild('editform') editform: SiteEditComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data != null) {

      this.site = data.entity2edit;
      this.configUI();
    }
  }

  configUI(){
    if (this.site==null){
      this.title='<i class="far fa-plus-square"></i> New Site';
      this.titlesub="Please enter minimum data to create a site";
    }
    else{
      this.title='<i class="far fa-edit"></i> Edit Site';
      this.titlesub="";
    }
  }

  saveModel() {
    this.editform.saveModel();

  }

  isvalid() {
    if (this.editform != null) {//en el inicio no es accesible
      return this.editform.isvalid();
    }
    else {
      return false;
    }

  }

  ngOnInit() {

  }
  ngAfterViewInit() {
    this.editform.saveEvent.subscribe((elemedited) => this.saveModelEvent(elemedited));
  }

  saveModelEvent(elemedited: Site) {
    this.saveEvent.emit(elemedited);
    this.submitted = false;
  }

  public static openModal(dialog: MatDialog, entity2edit: Site): MatDialogRef<SiteEditDlgComponent> {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "700px";
    dialogConfig.data = { entity2edit: entity2edit };

    let dialogRef: MatDialogRef<SiteEditDlgComponent>;
    dialogRef = dialog.open(SiteEditDlgComponent, dialogConfig);
    return dialogRef;
  }
}

/* 
{
  "zone": "Castilla La Mancha",
  "panel": {
    "cell": {
      "width": 0.125,
      "height": 0.125
    },
    "rows": 8,
    "type": 1,
    "width": 1.650,
    "height": 0.990,
    "columns": 9,
    "connection_box_location": "RL"
  },
  "power": 12,
  "matrix": {
    "rows": 48,
    "columns": 1,
    "orientation": "NS"
  },
  "report": {
    "locator": {
      "String": "L5",
      "Módulo": "L3",
      "Seguidor": "L2",
      "Instalación": "L1",
      "Combainer Box": "L4"
    }
  },
  "country": "ESP",
  "locator": {
    "L1": "instalacion",
    "L2": "seguidor",
    "L3": "modulo",
    "L4": "combiner",
    "L5": "string",
    "format": "B{L1:03d}-S{L2:02d}-M{L3:02d}-CB{L4:02d}-S{L5:02d}"
  },
  "location": [
    -1.79251038,
    39.0464399
  ],
  "created_by": "72bfd65c-3f4c-11ea-9075-509a4c837ab7",
  "updated_by": "72bfd65c-3f4c-11ea-9075-509a4c837ab7",
  "creation_date": "2020-08-26 09:43:15.094052",
  "updating_date": "2020-08-26 09:43:32.060807",
  "panel_locator_pattern": {
    "list": "B[L1]-S[L2]-M[L3]-CB[L4]-S[L5]",
    "maps": "B[L1]-S[L2]-M[L3]-CB[L4]-S[L5]"
  }
}
*/
